export default [
  {
    path: '/operations-management/region',
    name: 'region',
    component: () => import('@/views/pages/operations-management/Region.vue'),
    meta: {
      pageTitle: 'Region',
      hasPermission: 'VIEW_REGION',
      breadcrumb: [
        {
          text: 'Operations',
        },
        {
          text: 'Region',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/posting-approvals',
    name: 'posting-approvals',
    component: () => import('@/views/pages/operations-management/approvals/PostingApprovals.vue'),
    meta: {
      pageTitle: 'Posting Approvals Setup',
      hasPermission: 'VIEW_POSTING_APPROVAL',
      breadcrumb: [
        {
          text: 'Operations',
        },
        {
          text: 'Posting Approvals Setup',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/pending-approvals',
    name: 'pending-approvals',
    component: () => import('@/views/pages/operations-management/approvals/PendingApprovals.vue'),
    meta: {
      pageTitle: 'Pending Approvals',
      hasPermission: 'VIEW_PENDING_APPROVALS',
      breadcrumb: [
        {
          text: 'Operations',
        },
        {
          text: 'Pending Approvals',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/approval-requests',
    name: 'approvals-request',
    component: () => import('@/views/pages/operations-management/approvals/MyApprovals.vue'),
    meta: {
      pageTitle: 'My Approvals',
      hasPermission: 'VIEW_MY_APPROVALS',
      breadcrumb: [
        {
          text: 'Operations',
        },
        {
          text: 'My Approvals',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/approvals',
    name: 'all-approvals',
    component: () => import('@/views/pages/operations-management/approvals/AllApprovals.vue'),
    meta: {
      pageTitle: 'All Approvals',
      hasPermission: 'VIEW_ALL_APPROVALS',
      breadcrumb: [
        {
          text: 'Operations',
        },
        {
          text: 'All Approvals',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/audit-trail',
    name: 'audit-trail',
    component: () => import('@/views/pages/operations-management/AuditTrail.vue'),
    meta: {
      pageTitle: 'Audit Trail',
      hasPermission: 'AUDIT_TRAIL',
      breadcrumb: [
        {
          text: 'Operations',
        },
        {
          text: 'Audit Trail',
          active: true,
        },
      ],
    },
  },
  // Business Automation
  {
    path: '/operations-management/other-businesses',
    name: 'other-businesses',
    component: () => import('@/views/pages/operations-management/business-automation/OtherBusiness.vue'),
    meta: {
      pageTitle: 'Other Businesses Automation',
      hasPermission: 'VIEW_BUSINESS_AUTOMATION',
      breadcrumb: [
        {
          text: 'Operations',
        },
        {
          text: 'Other Businesses Automation',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/till-account',
    name: 'till-account',
    component: () => import('@/views/pages/operations-management/business-automation/TillAccount.vue'),
    meta: {
      pageTitle: 'Till Account Setup',
      hasPermission: 'VIEW_BUSINESS_AUTOMATION',
      breadcrumb: [
        {
          text: 'Operations',
        },
        {
          text: 'Till Account Setup',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/mobile-till-account',
    name: 'mobile-till-account',
    component: () => import('@/views/pages/operations-management/business-automation/MobileTillAccount.vue'),
    meta: {
      pageTitle: 'Mobile Till Account Setup',
      hasPermission: 'VIEW_BUSINESS_AUTOMATION',
      breadcrumb: [
        {
          text: 'Operations',
        },
        {
          text: 'Mobile Till Account Setup',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/vault-account',
    name: 'vault-account',
    component: () => import('@/views/pages/operations-management/business-automation/VaultAccount.vue'),
    meta: {
      pageTitle: 'Vault Account Setup',
      hasPermission: 'VIEW_BUSINESS_AUTOMATION',
      breadcrumb: [
        {
          text: 'Operations',
        },
        {
          text: 'Vault Account Setup',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/shortages-account',
    name: 'shortages-account',
    component: () => import('@/views/pages/operations-management/business-automation/ShortagesAccount.vue'),
    meta: {
      pageTitle: 'Shortages Account Setup',
      hasPermission: 'VIEW_BUSINESS_AUTOMATION',
      breadcrumb: [
        {
          text: 'Operations',
        },
        {
          text: 'Shortages Account Setup',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/overage-account',
    name: 'overage-account',
    component: () => import('@/views/pages/operations-management/business-automation/OverageAccount.vue'),
    meta: {
      pageTitle: 'Overage Account Setup',
      hasPermission: 'VIEW_BUSINESS_AUTOMATION',
      breadcrumb: [
        {
          text: 'Operations',
        },
        {
          text: 'Overage Account Setup',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/cash-suspense-account',
    name: 'cash-suspense-account',
    component: () => import('@/views/pages/operations-management/business-automation/CashSuspenseAccount.vue'),
    meta: {
      pageTitle: 'Cash Suspense Account',
      hasPermission: 'VIEW_BUSINESS_AUTOMATION',
      breadcrumb: [
        {
          text: 'Operations',
        },
        {
          text: 'Cash Suspense Account',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/inter-branch-transaction',
    name: 'inter-branch-transaction',
    component: () => import('@/views/pages/operations-management/business-automation/InterBranchTransaction.vue'),
    meta: {
      pageTitle: 'Inter Branch Transaction',
      hasPermission: 'VIEW_BUSINESS_AUTOMATION',
      breadcrumb: [
        {
          text: 'Operations',
        },
        {
          text: 'Inter Branch Transaction',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/cheque-clearing-account',
    name: 'cheque-clearing-account',
    component: () => import('@/views/pages/operations-management/business-automation/ChequeClearingAccount.vue'),
    meta: {
      pageTitle: 'Cheque Clearing Account Setup',
      hasPermission: 'VIEW_BUSINESS_AUTOMATION',
      breadcrumb: [
        {
          text: 'Operations',
        },
        {
          text: 'Cheque Clearing Account Setup',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/cheque-receivable-account',
    name: 'cheque-receivable-account',
    component: () => import('@/views/pages/operations-management/business-automation/ChequeReceivableAccount.vue'),
    meta: {
      pageTitle: 'Cheque Receivable Account',
      hasPermission: 'VIEW_BUSINESS_AUTOMATION',
      breadcrumb: [
        {
          text: 'Operations',
        },
        {
          text: 'Cheque Receivable Account',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/uncleared-cheque-account',
    name: 'uncleared-cheque-account',
    component: () => import('@/views/pages/operations-management/business-automation/UnclearedChequeAccount.vue'),
    meta: {
      pageTitle: 'Uncleared Cheque Account',
      hasPermission: 'VIEW_BUSINESS_AUTOMATION',
      breadcrumb: [
        {
          text: 'Operations',
        },
        {
          text: 'Uncleared Cheque Account',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/business',
    name: 'business',
    component: () => import('@/views/pages/operations-management/Business.vue'),
    meta: {
      pageTitle: 'Business',
      hasPermission: 'OPEN_CLOSE_BUSINESS_HISTORY',
      breadcrumb: [
        {
          text: 'Operations',
        },
        {
          text: 'Business',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/branch',
    name: 'branch',
    component: () => import('@/views/pages/operations-management/Branch.vue'),
    meta: {
      pageTitle: 'Branch',
      hasPermission: 'VIEW_BRANCH',
      breadcrumb: [
        {
          text: 'Operations',
        },
        {
          text: 'Branch',
          active: true,
        },
      ],
    },
  },
  // configurations
  {
    path: '/operations-management/corporate-information',
    name: 'configuration',
    component: () => import('@/views/pages/operations-management/configurations/configurations/index.vue'),
    meta: {
      pageTitle: 'Configurations',
      hasPermission: 'VIEW_SYSTEM_SETUP',
      breadcrumb: [
        {
          text: 'Configurations and Settings',
        },
        {
          text: 'Configurations',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/institution-limit',
    name: 'institution-limit',
    component: () => import('@/views/pages/operations-management/configurations/institutions/index.vue'),
    meta: {
      pageTitle: 'Institution Limit',
      hasPermission: 'VIEW_SYSTEM_SETUP',
      breadcrumb: [
        {
          text: 'Configurations and Settings',
        },
        {
          text: 'Institution Limit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/sms-email-notification',
    name: 'sms-email-notification',
    component: () => import('@/views/pages/operations-management/notifications/SmsEmail.vue'),
    meta: {
      pageTitle: 'SMS & Email Notifications',
      hasPermission: 'VIEW_COMMS_TEMPLATE',
      breadcrumb: [
        {
          text: 'SMS & Email Notifications',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/view-email-report',
    name: 'view-email-report',
    component: () => import('@/views/pages/operations-management/notifications/EmailReport.vue'),
    meta: {
      pageTitle: 'Email Report',
      hasPermission: 'VIEW_EMAIL_REPORT',
      breadcrumb: [
        {
          text: 'Email Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/view-sms-report',
    name: 'view-sms-report',
    component: () => import('@/views/pages/operations-management/notifications/SMSReport.vue'),
    meta: {
      pageTitle: 'SMS Report',
      hasPermission: 'VIEW_SMS_REPORT',
      breadcrumb: [
        {
          text: 'SMS Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/webhook-notifications',
    name: 'webhook-notifications',
    component: () => import('@/views/pages/operations-management/notifications/Webhook.vue'),
    meta: {
      pageTitle: 'Webhook Notifications',
      hasPermission: 'WEBHOOK_NOTIFICATION_REPORT',
      breadcrumb: [
        {
          text: 'Webhook Notifications',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/utility/bulk-sms',
    name: 'bulk-sms',
    component: () => import('@/views/pages/operations-management/utility/BulkSMS.vue'),
    meta: {
      pageTitle: 'Bulk SMS',
      hasPermission: 'BULK_SMS',
      breadcrumb: [
        {
          text: 'Bulk SMS',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/utility/recompute-loan-status',
    name: 'recompute-loan-status',
    component: () => import('@/views/pages/operations-management/utility/RecomputeLoanStatus.vue'),
    meta: {
      pageTitle: 'Recompute Loan Status',
      hasPermission: 'RECOMPUTE_EOD_BALANCE',
      breadcrumb: [
        {
          text: 'Recompute Loan Status',
          active: true,
        },
      ],
    },
  },
  {

    path: '/operations-management/utility/recompute-eod-balance',
    name: 'recompute-eod-balance',
    component: () => import('@/views/pages/operations-management/utility/RecomputeEODBalance.vue'),
    meta: {
      pageTitle: 'Recompute EOD Balance',
      hasPermission: 'RECOMPUTE_EOD_BALANCE',
      breadcrumb: [
        {
          text: 'Recompute EOD Balance',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/utility/view-sms-wallet',
    name: 'view-sms-wallet',
    component: () => import('@/views/pages/operations-management/utility/SMSWallet.vue'),
    meta: {
      pageTitle: 'View SMS Wallet',
      hasPermission: 'VIEW_SMS_WALLET',
      breadcrumb: [
        {
          text: 'View SMS Wallet',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/utility/view-kyc-wallet',
    name: 'view-kyc-wallet',
    component: () => import('@/views/pages/operations-management/utility/KYCWallet.vue'),
    meta: {
      pageTitle: 'View KYC Wallet',
      hasPermission: 'VIEW_KYC_WALLET',
      breadcrumb: [
        {
          text: 'View KYC Wallet',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/multi-currency/currency',
    name: 'currency',
    component: () => import('@/views/pages/operations-management/multi-currencies/Currency.vue'),
    meta: {
      pageTitle: 'Currency',
      hasPermission: 'VIEW_CURRENCY',
      breadcrumb: [
        {
          text: 'Currency',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/multi-currency/currency-rates',
    name: 'currency-rates',
    component: () => import('@/views/pages/operations-management/multi-currencies/CurrencyRates.vue'),
    meta: {
      pageTitle: 'Currency Rates',
      hasPermission: 'VIEW_CURRENCY_RATE',
      breadcrumb: [
        {
          text: 'Currency Rates',
          active: true,
        },
      ],
    },
  },
  // {
  //   path: '/operations-management/corporate-information',
  //   name: 'corporate-information',
  //   component: () => import('@/views/pages/operations-management/configurations/CorporateInformation.vue'),
  //   meta: {
  //     pageTitle: 'Corporate Information',
  //     hasPermission: 'VIEW_SYSTEM_SETUP',
  //     breadcrumb: [
  //       {
  //         text: 'Configurations and Settings',
  //       },
  //       {
  //         text: 'Corporate Information',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/operations-management/eod-configuration',
  //   name: 'eod-configuration',
  //   component: () => import('@/views/pages/operations-management/configurations/EODConfiguration.vue'),
  //   meta: {
  //     pageTitle: 'EOD Configuration',
  //     hasPermission: 'VIEW_SYSTEM_SETUP',
  //     breadcrumb: [
  //       {
  //         text: 'Configurations and Settings',
  //       },
  //       {
  //         text: 'EOD Configuration',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/operations-management/tax-information',
  //   name: 'tax-information',
  //   component: () => import('@/views/pages/operations-management/configurations/TaxInformation.vue'),
  //   meta: {
  //     pageTitle: 'Tax Information',
  //     hasPermission: 'VIEW_SYSTEM_SETUP',
  //     breadcrumb: [
  //       {
  //         text: 'Configurations and Settings',
  //       },
  //       {
  //         text: 'Tax Information',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/operations-management/interest-information',
  //   name: 'interest-information',
  //   component: () => import('@/views/pages/operations-management/configurations/InterestInformation.vue'),
  //   meta: {
  //     pageTitle: 'Interest Information',
  //     hasPermission: 'VIEW_SYSTEM_SETUP',
  //     breadcrumb: [
  //       {
  //         text: 'Configurations and Settings',
  //       },
  //       {
  //         text: 'Interest Information',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/operations-management/institution-fileupload',
  //   name: 'institution-fileupload',
  //   component: () => import('@/views/pages/operations-management/configurations/InstitutionFileUpload.vue'),
  //   meta: {
  //     pageTitle: 'Institution File Upload',
  //     hasPermission: 'VIEW_SYSTEM_SETUP',
  //     breadcrumb: [
  //       {
  //         text: 'Configurations and Settings',
  //       },
  //       {
  //         text: 'Institution File Upload',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/operations-management/other-configuration',
  //   name: 'other-configuration',
  //   component: () => import('@/views/pages/operations-management/configurations/OtherConfiguration.vue'),
  //   meta: {
  //     pageTitle: 'Other Configuration',
  //     hasPermission: 'VIEW_SYSTEM_SETUP',
  //     breadcrumb: [
  //       {
  //         text: 'Configurations and Settings',
  //       },
  //       {
  //         text: 'Other Configuration',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/operations-management/working-day',
  //   name: 'working-day',
  //   component: () => import('@/views/pages/operations-management/configurations/WorkingDayConfiguration.vue'),
  //   meta: {
  //     pageTitle: 'Working Day',
  //     hasPermission: 'VIEW_SYSTEM_SETUP',
  //     breadcrumb: [
  //       {
  //         text: 'Configurations and Settings',
  //       },
  //       {
  //         text: 'Working Day',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/operations-management/public-holiday',
  //   name: 'public-holiday',
  //   component: () => import('@/views/pages/operations-management/configurations/PublicHolidayConfiguration.vue'),
  //   meta: {
  //     pageTitle: 'Public Holiday',
  //     hasPermission: 'VIEW_SYSTEM_SETUP',
  //     breadcrumb: [
  //       {
  //         text: 'Configurations and Settings',
  //       },
  //       {
  //         text: 'Public Holiday',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/operations-management/account-tier-level',
  //   name: 'account-tier-level',
  //   component: () => import('@/views/pages/operations-management/configurations/AccountTierLevelConfiguration.vue'),
  //   meta: {
  //     pageTitle: 'Account Tier Level',
  //     hasPermission: 'VIEW_SYSTEM_SETUP',
  //     breadcrumb: [
  //       {
  //         text: 'Configurations and Settings',
  //       },
  //       {
  //         text: 'Account Tier Level',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  {
    path: '/operations-management/setup',
    name: 'setup',
    component: () => import('@/views/pages/operations-management/approvals/Setup.vue'),
    meta: {
      pageTitle: 'Non Posting Approval Setup',
      hasPermission: 'VIEW_APPROVAL_SETUP',
      breadcrumb: [
        {
          text: 'Operations',
        },
        {
          text: 'Non Posting Approval Setup',
          active: true,
        },
      ],
    },
  },
  {
    path: '/operations-management/:type/approval-setup/:id?',
    name: 'approval-setup',
    component: () => import('@/views/pages/operations-management/approvals/ApprovalSetup.vue'),
    meta: {
      pageTitle: 'Setup',
      hasPermission: 'MODIFY_APPROVAL_SETUP',
      breadcrumb: [
        {
          text: 'Operations',
        },
        {
          text: 'Setup',
          active: true,
        },
      ],
    },
  },
]
